import { useEffect, useState } from "react";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { useData } from "../../../context/DataContext";
import { updateTrainingPlan } from '../../../context/createAPI'
import { Box, Card, CardContent, Grid, Divider, TextField, CardActions } from "@mui/material";
import SingleSelect from "../../../components/Selections/singleSelect";
import CustomButton from "../../../components/buttons/customButton";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SnackbarMessage from "../../../components/snackBar/snackBar";

const initialState = {
    trainingName: "",
    trainingDate: moment().format("YYYY-MM"),
    year: "",
    levelId: "",
    trainingTopic: "",
    targetGroup: "",
    resourcePerson: "",
    trainingMethodology: "",
    comments: "",
    loading: false,
    submitMessage: "",
    trainingTypeId: "",
}

function TrainingCreation() {
    const location = useLocation();
    const navigate = useNavigate()
    const { rowData } = location.state || {};
    const { user = {}, years = [], levels = [], handleTrainingPlans, trainingTypes = [] } = useData();
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const [state, setState] = useState(initialState);
    const [errors, setErrors] = useState({});

    const handleInputChange = (name, value) => {
        setState((prev) => ({
            ...prev,
            [name]: value,
        }));
        setErrors({});
    };

    useEffect(() => {
        if (Object.keys(rowData).length > 0) {
            const timestamp = rowData.month_of_training * 1000;
            const formattedDate = moment(parseInt(timestamp)).format("YYYY-MM");

            setState((prevState) => ({
                ...prevState,
                trainingName: rowData.training_content,
                trainingTypeId: rowData.training_type_id,
                trainingDate: formattedDate,
                year: rowData.year,
                levelId: rowData.level_id,
                trainingTopic: rowData.training_topics,
                targetGroup: rowData.target_group,
                resourcePerson: rowData.resource_person,
                trainingMethodology: rowData.training_methodology,
                comments: rowData.comments,
            }));
        } else {
            setState((prevState) => ({
                ...prevState,
                trainingName: "",
                trainingDate: moment().format("YYYY-MM"),
                year: "",
                levelId: "",
                trainingTopic: "",
                targetGroup: "",
                resourcePerson: "",
                trainingMethodology: "",
                comments: "",
            }));
        }

    }, [rowData])

    const handleTrainingUpdateSubmit = async (e) => {
        e.preventDefault();
        const formErrors = {};
        if (!state.trainingName) formErrors.trainingName = "Enter Training Name";
        if (!state.levelId) formErrors.levelId = "Select Level";
        if (!state.trainingTopic) formErrors.trainingTopic = "Enter Topic";
        if (!state.targetGroup) formErrors.targetGroup = "Enter Target Group";
        if (!state.trainingDate) formErrors.trainingDate = "Select Date";
        if (!state.resourcePerson) formErrors.resourcePerson = "Enter Resource Person";
        if (!state.trainingMethodology) formErrors.trainingMethodology = "Enter Methodology";
        if (!state.trainingTypeId) formErrors.trainingTypeId = "Select Training Type";


        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
        } else {
            setState((prevState) => ({
                ...prevState,
                loading: true
            }));
            try {
                const updateApi = await updateTrainingPlan({
                    id: rowData.id,
                    level_id: state.levelId,
                    training_type_id: state.trainingTypeId,
                    training_content: state.trainingName.replace(/\n/g, " "),
                    year: years[0].value,
                    month_of_training: state.trainingDate,
                    new_training_topics: state.trainingTopic.replace(/\n/g, " "),
                    new_target_group: state.targetGroup.replace(/\n/g, " "),
                    new_resource_person: state.resourcePerson.replace(/\n/g, " "),
                    new_training_methodology: state.trainingMethodology.replace(/\n/g, " "),
                    new_comments: state.comments.replace(/\n/g, " "),
                    updated_by: user.user_id,
                    client_id: parseInt(localStorage.getItem("user_client_id")),
                });
                if (updateApi.statusCode === 200) {
                    handleTrainingPlans();
                    setState((prevState) => ({
                        ...prevState,
                        loading: false,
                        submitMessage: updateApi.data
                    }));

                    setSnackbar({
                        open: true,
                        message: updateApi.data,
                        severity: "success",
                    });

                    setTimeout(() => {
                        navigate(-1);
                    }, 2000);

                }

            } catch (error) {
                console.error(error);
                setSnackbar({
                    open: true,
                    message: error,
                    severity: "success",
                });
            }
        }
    }

    const { trainingTypeId, year, levelId, trainingName, trainingDate, trainingTopic, targetGroup, resourcePerson, trainingMethodology, comments } = state;

    return (
        <Box>

            <Card elevation={6}>
                <CardContent>
                    <Box
                        display="flex"
                        justifyContent="flex-start"
                        alignItems="center"
                    >
                        <CustomButton
                            label="Back"
                            status={false}
                            onClick={() => navigate(-1)}
                            icon={<ArrowBackIcon />}
                        />
                    </Box>

                    <Divider sx={{ my: 0, bgcolor: '#f5f1f1ff' }} />

                    <Box sx={{ p: 2 }}>
                        <Grid container spacing={2}>
                            {[
                                { id: 1, name: "trainingTypeId", value: trainingTypeId, label: "Training Type", type: "select", options: trainingTypes, error: errors.trainingTypeId },
                                { id: 2, name: "trainingName", value: trainingName, label: "Training Name", type: "textarea", limit: 150, error: errors.trainingName, rows: 3 },
                                { id: 3, name: "trainingDate", value: trainingDate, label: "Training Month", type: "month", error: errors.trainingDate },

                                { id: 4, name: "year", label: "Training Year", type: "select", value: years[0]?.value ?? year, options: [years[0]], disabled: true, error: errors.year },
                                { id: 5, name: "levelId", label: "Levels", value: levelId, type: "select", options: levels, error: errors.levelId },
                                { id: 6, name: "trainingTopic", value: trainingTopic, label: "Training Topic", type: "textarea", limit: 300, error: errors.trainingTopic, rows: 3 },

                                { id: 7, name: "targetGroup", value: targetGroup, label: "Target Audience", type: "textarea", limit: 300, error: errors.targetGroup, rows: 3 },
                                { id: 8, name: "resourcePerson", value: resourcePerson, label: "Resource Person", type: "textarea", limit: 300, error: errors.resourcePerson, rows: 3 },
                                { id: 9, name: "trainingMethodology", value: trainingMethodology, label: "Training Methodology", type: "textarea", limit: 300, error: errors.trainingMethodology, rows: 3 },
                                { id: 10, name: "comments", value: comments, label: "Comments", type: "textarea", limit: 500, rows: 3 },
                            ].map((field) => (
                                <Grid item size={{ xs: 12, md: 4 }} key={field.id}>
                                    {/* SELECT */}
                                    {field.type === "select" && (
                                        <SingleSelect
                                            name={field.name}
                                            label={field.label}
                                            options={field.options}
                                            value={field.value}
                                            disabled={field.disabled}
                                            onChange={handleInputChange}
                                            error={field.error}
                                            formHelperText={true}
                                        />
                                    )}

                                    {/* TEXTAREA */}
                                    {field.type === "textarea" && (
                                        <TextField
                                            fullWidth
                                            multiline
                                            rows={field.rows}
                                            name={field.name}
                                            label={field.label}
                                            value={field.value}
                                            onChange={(e) => handleInputChange(field.name, e.target.value)}
                                            inputProps={{ maxLength: field.limit }}
                                            error={!!field.error}
                                            helperText={
                                                field.error ||
                                                (field.limit
                                                    ? `${(state[field.name] || "").length}/${field.limit}`
                                                    : "")
                                            }
                                        />
                                    )}

                                    {/* MONTH */}
                                    {field.type === "month" && (
                                        <TextField
                                            fullWidth
                                            type="month"
                                            size="small"
                                            name={field.name}
                                            label={field.label}
                                            value={field.value}
                                            onChange={(e) => handleInputChange(field.name, e.target.value)}
                                            error={!!field.error}
                                            helperText={field.error}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )}
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    <Divider sx={{ bgcolor: '#f5f1f1ff' }} />
                </CardContent>
                <CardActions sx={{ justifyContent: "center", mb: 1, mt: 1 }}>
                    <CustomButton
                        status={state.loading === true ? "loading" : "idle"}
                        onClick={handleTrainingUpdateSubmit}
                        label=" Create Plan"
                        loadingLabel="Submitting.."
                    />
                </CardActions>
            </Card>
            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </Box>
    )
}

export default TrainingCreation;
